// extracted by mini-css-extract-plugin
module.exports = {"main":"ContractItem_main__oU8Qw","card":"ContractItem_card__2N8TG","link":"ContractItem_link__2AluO"};